export const file = {
  restrictions: 'Ograniczenia',
  maxFileSize: 'Maksymalny rozmiar pliku',
  maxFiles: 'Maksymalna liczba plików',
  allowedTypes: 'Dozwolone rozszerzenia plików',
  noFile: 'Brak pliku',
  fileAdded: 'Plik został pomyślnie przesłany',
  invalidFileType: 'Nieprawidłowy typ pliku',
}
